import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "./_utils";

const badgeVariants = cva(
  "inline-flex items-center gap-xs rounded-full font-medium",
  {
    variants: {
      variant: {
        neutral: "bg-[var(--print-bg)] text-text-secondary",
        success: "bg-success-muted text-success",
        warning: "bg-warning-muted text-warning",
        error: "bg-error-muted text-error",
        info: "bg-info-muted text-info",
        amber: "bg-warning-muted text-warning",
        teal: "bg-info-muted text-info",
      },
      size: {
        xs: "h-4 px-xs text-xs",
        sm: "h-5 px-sm text-sm",
      },
    },
    defaultVariants: { variant: "neutral", size: "sm" },
  }
);

type BadgeProps = React.HTMLAttributes<HTMLSpanElement> &
  VariantProps<typeof badgeVariants>;

/**
 * Inline status tag. Used for counts, states, categories.
 *
 * @example
 * <Badge>Neutral</Badge>
 * <Badge variant="success">Synced</Badge>
 * <Badge variant="warning" size="xs">Pending</Badge>
 * <Badge variant="error">Failed</Badge>
 * <Badge variant="info">New</Badge>
 */
export function Badge({ className, variant, size, ...props }: BadgeProps) {
  return (
    <span
      className={cn(badgeVariants({ variant, size }), className)}
      {...props}
    />
  );
}
